const str = `{HEADER}利用規約
{BODY_TITLE}1 – コンテンツ製作及び再発行原則
ビデオモンスターサービスを活用して製作する著作物は､有害な内容か、違法サービスの広報、広告に活用されてはなりません。
また、ブランドソリューション協議における両者の約束と了解がいない限り、ビデオモンスターを活用して製作した著作物の再販売を固く禁じます。

{BODY_TITLE}2 – 知的財産
① 利用及び配布の権利を完全に持つ利用者が直接入力した文や写真、ビデオクリップ以外、videomonster.com内の全ての知的財産は(株)ビデオモンスター、
並びに、パートナー(協力社)及びサービス提供者の財産です。また、利用者は利用や配布における完全な権利を持たないコンテンツをビデオモンスターへアップロードしないことを原則とします。
{ADD_LINE}
② 著作物が「情報通信網法」及び「著作権法」などの関連法に違反する内容を含む場合、権利者は疎明資料(権利者であることを疎明する資料と権利侵害事実を疎明する資料)を添付し、Eメールまたは郵便にてビデオモンスターに該当著作物の掲示中断及び削除を要請することができます。
{ADD_LINE}
③ ビデオモンスターは権利者に進行状況を通知し、関連法に基づき措置をとります。ビデオモンスターが必要な措置をとった場合、当該事実を申出人と情報掲載者に通知して、該当掲示板またはサービスの初期画面に公示するなどの方法にて利用者にお知らせます。
{ADD_LINE}
④ ビデオモンスターは権利者の要請がない場合でも権利侵害が認められる事由、その他に当社の政策及び関連法に違反する場合には関連法に基づき該当著作物へのアクセスを臨時遮断する措置(以下、「臨時措置」といいます)などが取ることができます。
{ADD_LINE}
⑤ ビデオモンスターは第2項に基づいた情報の削除要請にもかかわらず、権利の侵害について判断し難い場合や当事者間の紛争が予想される場合、30日以内の期間を定めて該当情報に臨時措置を行うことができます。

{BODY_TITLE}3 – 支払い
ビデオモンスターのサービスには各動画ごとの個別決済と月定期決済があります。
決済に関する詳しい情報は、決済ページをご確認ください。その他のお問い合わせはビデオモンスターチャット、代表番号、Eメールなどにてご自由にお問い合わせください。
ビデオモンスターは利用者の個人情報を保護するため、情報通信網の利用促進及び情報保護などに関する法律、そして個人情報保護法などの関係法令に定められた規定をを遵守します。
個人情報の保護及び利用については、関連法令及びビデオモンスターのプライバシーポリシーが適用されます。
{ADD_LINE}
ビデオモンスターは利用者の個人情報を保護するため、プライバシーポリシーを制定し、ウェブサイトの初期画面に掲示します。但し、プライバシーポリシーの具体的内容はアクセス画面にて確認できます。
{ADD_LINE}
ビデオモンスターは利用契約のために利用者が提供した情報をビデオモンスターのサービス運営以外の用途で利用したり、利用者の同意なしに第三者に提供しません。
{ADD_LINE}
当社は、利用者の個人情報を貴下の個人情報、支払内訳、ビデオを製作するために ビデオモンスターに提出したコンテンツ(テキスト、写真、ビデオクリップなど)と定義します。
{ADD_LINE}
これは当社のサーバーに貴下の個人情報を保存する手続きまで含みます。また、自動(コンピュータプロセス)や手動(人が直接処理する)の方法を全て利用し、貴下が製作したビデオファイルの品質を点検することも含みます。
{ADD_LINE}
当社のサーバーは国際ネットワークを基盤とします。したがって、ビデオモンスターを利用することにより貴下はご本人のデータを全世界における当社のサーバーへ保存することを同意することになります。現在、当社のサーバーはアメリカ、日本、大韓民国にあり、今後、南アメリカ、香港、そして以後に決められるその他国にもさらにサーバーを拡充する計画です。

{BODY_TITLE}4 – 個人情報保護
ビデオモンスターはデータ、ビデオモンスターサービス及び関連技術の利用、成果に関わる他の情報を収集、利用及び分析することができます。また、これらを事業的に利用することや事業関連の統計的または識別不可能な形態で公開することができます。どのような情報が収集及び利用されるかは、プライバシーポリシーにてより詳しく確認することができます。

{BODY_TITLE}5 – 共有
利用者がビデオモンスターで製作した動画のうち、ビデオモンスターが自主製作したテンプレートは私的用途で自由に共有でき、また商業的用途(広告の素材活用など)でも自由に活用できます。
テンプレートセレクトショップで選択して製作した動画の場合、一部異なる規定が適用されることがあります。それらの事項は特定のショップにて告示します。

{BODY_TITLE}6 – 第三者サービス
ビデオモンスターには利用者経験の一部に含まれる様々な第三者サービスが存在します。ビデオモンスターを利用することで、利用者はこのような別途の第三者サービスの規約もまた同意することになります。
ビデオモンスターで利用する第三者サービスは、支払手続(イニシスなど)、Facebookなどを含みます。

{BODY_TITLE}7 – 限定的保証
(株)ビデオモンスターは利用者に限定的保証を提供します。
ビデオモンスターで利用者が製作したビデオは、不具合がないことを原則とします。
もし、利用者が製作したビデオに不具合がある場合、ビデオモンスターは無料で再製作できるよう代替します。
不具合に貴下が製作した文の誤字を含みません。但し、当社が製作した文の誤字は含みます。
また、不具合の範囲に利用者から提供された写真やビデオクリップ自体の問題は含みません。但し、その他の写真やビデオシークエンスによる問題、レンダリング過程で発生したエラー、
即ち、ビデオモンスターの過ちで発生した問題は不具合に含まれます。 ビデオモンスターは最高のサービスを最適の価格で提供できるよう常に苦心しています。
限定的保証に関する異議や質問がある場合、当社のカスタマーセンターやEメール(hello@videomonster.com)、代表番号などまでお問い合わせください。

{BODY_TITLE}8 – 免責、法的責任の限定
上記の限定的保証の内容以外、ビデオモンスターの全的な責任範囲は、利用者が過去365日以内にビデオモンスターへ支払った金額の総額を超えないことに利用者の同意を得たとみなします。
もし、利用者が過去365日以内にビデオモンスターにいかなる料金も支払っていない場合、貴下へのビデオモンスターの全体責任は1,000ウォンまでとします。
ビデオモンスターが天災地変またはそれに準ずる不可抗力よりサービス提供ができない場合、サービス提供における責任が免除されます。
ビデオモンスターは、利用者の帰責事由によるサービス利用障害については責任を負いません。

{BODY_TITLE}9 – 紛争解決
ビデオモンスターは利用者からの正当な意見や苦情を反映し、その被害を補償するための被害補償処理機構を設置及び運営します。
ビデオモンスターは利用者からの苦情や意見を優先的に処理します。但し、迅速な処理が難しい場合は、利用者にその理由と処理日程を直ちに通知します。

{BODY_TITLE}10 - 準拠法及び管轄裁判所
該当規約の解析及びビデオモンスターと利用者間の紛争に関しては大韓民国の法令を適用します。
ビデオモンスターのサービス利用中に発生したビデオモンスターと利用者間の訴訟はソウル中央地方裁判所に提訴します。

{FOOTER}
{FOOTER_SUB}この規約は、2019年5月5日から適用されます。
`

export default str